import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingColumns: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 0H0v4h7zm9 0H9v4h7zM0 6h7v4H0zm16 0H9v4h7zM0 12h7v4H0zm16 0H9v4h7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingColumns
